export default __webpack_public_path__ + "static/media/bg-image.7803d4dd.png";